import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.js%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../../public/fonts/brand/morris/albra/BumbumType-Albra-Light.otf%22,%22weight%22:%22300%22},{%22path%22:%22../../../../public/fonts/brand/morris/albra/BumbumType-Albra-Light-Italic.otf%22,%22style%22:%22italic%22,%22weight%22:%22300%22},{%22path%22:%22../../../../public/fonts/brand/morris/albra/BumbumType-Albra-Regular.otf%22,%22weight%22:%22400%22},{%22path%22:%22../../../../public/fonts/brand/morris/albra/BumbumType-Albra-Regular-Italic.otf%22,%22style%22:%22italic%22,%22weight%22:%22400%22}],%22variable%22:%22--brand-font%22}],%22variableName%22:%22bumbumAlbraFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'bumbumAlbraFont', 'bumbumAlbraFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
